const arrayToObjectByKeyObject = (array, idKey = 'id') => {
  return array.reduce((obj, item) => {
    obj[item[idKey]] = item
    return obj
  }, {})
}

export default arrayToObjectByKeyObject
